import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { keyboardShortcuts } from '../utils/keyboardShortcuts';

const KeyboardShortcutHandler = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleKeyDown = (e) => {
      // Check for modifier keys
      const ctrlKey = e.ctrlKey || e.metaKey; // Support both Ctrl and Cmd
      const altKey = e.altKey;
      const shiftKey = e.shiftKey;
      
      // Build the key combination
      let keyCombination = '';
      if (ctrlKey) keyCombination += 'ctrl+';
      if (altKey) keyCombination += 'alt+';
      if (shiftKey) keyCombination += 'shift+';
      keyCombination += e.key && typeof e.key === 'string' ? e.key.toLowerCase() : '';

      // Check if the key combination matches any shortcut
      Object.values(keyboardShortcuts).forEach(category => {
        if (category[keyCombination]) {
          e.preventDefault();
          const shortcut = category[keyCombination];
          
          // Handle the shortcut action
          switch (shortcut.action) {
            case 'dashboard':
              navigate('/');
              break;
            case 'sales':
              navigate('/sales');
              break;
            case 'customers':
              navigate('/customers');
              break;
            case 'items':
              navigate('/items');
              break;
            case 'reports':
              navigate('/reports');
              break;
            case 'search':
              // Focus on search input if available
              const searchInput = document.querySelector('input[type="search"]');
              if (searchInput) {
                searchInput.focus();
              }
              break;
            case 'refresh':
              window.location.reload();
              break;
            // Add more cases for other actions
            default:
              console.log(`Shortcut ${keyCombination} pressed: ${shortcut.description}`);
          }
        }
      });
    };

    window.addEventListener('keydown', handleKeyDown);
    return () => {
      window.removeEventListener('keydown', handleKeyDown);
    };
  }, [navigate]);

  return null; // This component doesn't render anything
};

export default KeyboardShortcutHandler; 